module.exports = __webpack_public_path__ + "img/full3-min.360d6886.png";